import { track } from '@amplitude/unified';
import React from 'react';
import { HashLink } from 'react-router-hash-link';

export default function Footer() {
  return (
    <>
    <section className="footer">
        <div className="container">
            <div className="footer--container">
                <div className="footer__logo">
                    <HashLink onClick={() => {track('Footer Link Clicked', { linkName: 'Logo', destination: 'Home' });}} to={"/#home"}><img src="/images/footerlogo.svg" alt="" /></HashLink>
                </div>
                <div className="footer__menu">
                    <ul>
                        <HashLink onClick={() => {track('Footer Link Clicked', { linkName: 'Home', destination: 'Home' });}} to={"/#home"} smooth><li>Home</li></HashLink>
                        <HashLink onClick={() => {track('Footer Link Clicked', { linkName: 'About Us', destination: 'About Us' });}} to={"/about-us/#about"} smooth><li>About us</li></HashLink>
                        <HashLink onClick={() => {track('Footer Link Clicked', { linkName: 'Team', destination: 'Team' });}} to={"/about-us/#our-team"} smooth><li>Team</li></HashLink>
                        <HashLink onClick={() => {track('Footer Link Clicked', { linkName: 'Contact Us', destination: 'Contact Us' });}} to={"/#contact-us"} smooth><li>Contact us</li></HashLink>
                        {/* <HashLink to={"/product#certificate"} smooth><li>Certificate</li></HashLink> */}
                    </ul>
                </div>
            </div>
           <div style={{display: "flex",flexDirection:"row", gap: "25px",justifyContent: "right"}}>
                <a onClick={() => {track('Social Media Clicked', { platform: 'LinkedIn' });}} href="https://www.linkedin.com/company/surya-rishi-tech/" target="_blank" rel="noopener noreferrer">
                    <img width={26} height={26} src="/images/LinkedIn_logo.png" alt="LinkedIn Profile"/>
                </a>
                <a onClick={() => {track('Social Media Clicked', { platform: 'YouTube' });}} href="https://www.youtube.com/@Surya_rishitech" target="_blank" rel="noopener noreferrer">
                    <img width={30} height={26} src="/images/Youtube_logo.png" alt="YouTube Channel"/>
                </a>
            </div> 
            <hr/>
            <div className="container paragraph text-xl-center " >
                <p style={{"font-weight":"500pt", "color":"rgba(255, 255, 255, 0.4)", "display": "flex", "flex-wrap": "nowrap", "justify-content": "center"}}>We use and manage your personal information in accordance with our (<a href='/Rishi Tech Pty Ltd - Privacy Policy (LV 23 Nov 2023).pdf'>Privacy policy</a>).</p>
            </div>
            <div className="footer__copyright">
                <p>Rishi Tech Pty Ltd © {new Date().getFullYear()} All Rights Reserved</p>
            </div>
        </div>
    </section>
    </>
  )
}
